import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmationModalService, IConfirmationModalParams } from 'src/app/providers/services/confirmation-modal.service';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {
  params: IConfirmationModalParams;

  private paramsSubscription: Subscription;

  constructor(
    private confirmationModalService: ConfirmationModalService
  ) { }

  ngOnInit(): void {
    this.paramsSubscription = this.confirmationModalService.modalParams$.subscribe(params => {
      this.params = params;
    });
  }

  ngOnDestroy(): void {
    if (this.paramsSubscription) { this.paramsSubscription.unsubscribe(); }
  }

}
